import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { Grid, withStyles } from '@material-ui/core'
import { DatePicker } from '@material-ui/pickers'
import { useTranslation } from 'react-i18next'

import CardPaper from './CardPaper'
import { PrimaryButton, TextField, SelectField } from '../default'
import { getMonthAndYearToPicker } from '../../class/utils'
import { LOG_CONST } from '../../class/constants'
import { acGetAllLogsByManagerId, acGetAllLogsByActionClass, acGetAllLogsByAction, acGetAllLogsByMonth } from '../../class/actions'

function CardSearchLog({
  classes
}) {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  // Error Controll
  const [typeError, setTypeError] = useState(false)
  const [validationError, setValidationError] = useState(false)

  // Search Type
  const [searchTypes, setSearchTypes] = useState([])
  const [selectedType, setSelectedType] = useState('')

  // Manager Id
  const [selectedManager, setSelectedManager] = useState('')

  // Action Class
  const [actionClasses, setActionClasses] = useState([])
  const [selectedActionClass, setSelectedActionClass] = useState('')

  // Action
  const [actions, setActions] = useState([])
  const [selectedAction, setSelectedAction] = useState('')

  // Month
  const [selectedMonth, setSelectedMonth] = useState(new Date())

  const renderSelect = () => {
    return (
      <SelectField
        label={t('panels.managerLog.selectField.label')}
        items={searchTypes}
        value={selectedType}
        onChange={e => setSelectedType(e.target.value)}
        error={typeError}
      />
    )
  }

  const renderManagerField = () => {
    return (
      <TextField
        light
        variant="filled"
        style={{ width: '100%', height: '100%' }}
        label={t('panels.managerLog.selectField.MANAGER')}
        placeholder={t('panels.managerLog.selectManagerField.label')}
        value={selectedManager}
        onChange={e => setSelectedManager(e.target.value)}
        error={validationError}
      />

    )
  }

  const renderActionClassSelect = () => {
    return (
      <SelectField
        label={t('panels.managerLog.selectField.ACTION_CLASS')}
        items={actionClasses}
        value={selectedActionClass}
        onChange={e => setSelectedActionClass(e.target.value)}
        error={validationError}
      />

    )
  }

  const renderActionSelect = () => {
    return (
      <SelectField
        label={t('panels.managerLog.selectField.ACTION')}
        items={actions}
        value={selectedAction}
        onChange={e => setSelectedAction(e.target.value)}
        error={validationError}
      />
    )
  }

  const renderMonthSelect = () => {
    return (
      <>
        <DatePicker
          label={t('panels.managerLog.selectField.MONTH')}
          inputVariant="filled"
          style={{ width: '100%', height: '100%' }}
          views={["month", "year"]}
          value={selectedMonth}
          onChange={e => setSelectedMonth(e)}
          error={validationError}
        />
      </>
    )
  }

  const validateAllBeforeSearch = () => {

    switch (selectedType) {

      case 'MANAGER':
        if (!selectedManager) {
          setValidationError(true);
          break;
        }
        else {
          dispatch(acGetAllLogsByManagerId(selectedManager))
            .catch(err => console.error(err))
          break;
        }

      case 'ACTION_CLASS':
        if (!selectedActionClass) {
          setValidationError(true);
          break;
        }
        else {
          dispatch(acGetAllLogsByActionClass(selectedActionClass))
            .catch(err => console.error(err))
          break;
        }

      case 'ACTION':
        if (!selectedAction) {
          setValidationError(true);
          break;
        }
        else {
          dispatch(acGetAllLogsByAction(selectedAction))
            .catch(err => console.error(err))
          break;
        }


      case 'MONTH':
        if (!selectedMonth) {
          setValidationError(true);
          break;
        }
        else {
          dispatch(acGetAllLogsByMonth(getMonthAndYearToPicker(selectedMonth)))
            .catch(err => console.error(err))
          break;
        }

      default:
        setTypeError(true)
        break;
    }

  }

  useEffect(() => {

    setSearchTypes(LOG_CONST.MANAGER.SEARCH_TYPES.map(searchType => {
      return {
        name: t(`panels.managerLog.selectField.${searchType}`),
        value: searchType
      }
    }))

    setActionClasses(LOG_CONST.MANAGER.ACTION_CLASSES.map(actionClass => {
      return {
        name: t(`panels.managerLog.selectActionClassField.${actionClass}`),
        value: actionClass
      }
    }))

    setActions(LOG_CONST.MANAGER.ACTIONS.map(action => {
      if (LOG_CONST.MANAGER.ACTION_CLASSES.includes(action)) {
        return {
          name: t(`panels.managerLog.selectActionClassField.${action}`),
          value: action,
          subheader: true
        }
      }
      return {
        name: t(`panels.managerLog.selectActionField.${action}`),
        value: action
      }

    }))

  }, [t])

  useEffect(() => {
    if (selectedType) {
      setTypeError(false)
      setValidationError(false)
    }
  }, [selectedType])

  useEffect(() => {
    if (selectedManager) {
      setValidationError(false)
    }
  }, [selectedManager])

  useEffect(() => {
    if (selectedActionClass) {
      setValidationError(false)
    }
  }, [selectedActionClass])

  useEffect(() => {
    if (selectedAction) {
      setValidationError(false)
    }
  }, [selectedAction])

  useEffect(() => {
    if (selectedMonth) {
      setValidationError(false)
    }
  }, [selectedMonth])

  return (

    <CardPaper>
      <div className={classes.form}>
        <Grid
          container
          spacing={2}
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item xs={5}>
            {renderSelect()}
          </Grid>
          <Grid item xs={5}>
            {selectedType === 'MANAGER' && (renderManagerField())}
            {selectedType === 'ACTION_CLASS' && (renderActionClassSelect())}
            {selectedType === 'ACTION' && (renderActionSelect())}
            {selectedType === 'MONTH' && (renderMonthSelect())}
          </Grid>
          <Grid item xs={2}>
            <PrimaryButton
              onClick={validateAllBeforeSearch}
              style={{ width: '100%', height: '100%' }}
            >
              {t('cards.search.btn')}
            </PrimaryButton>
          </Grid>
        </Grid>
      </div>
    </CardPaper>

  )
}

CardSearchLog.propTypes = {
  onSearch: PropTypes.func,
}

CardSearchLog.defaultProps = {
  onSearch: () => true
}

const styles = theme => ({
  form: {
    display: 'flex',
    alignItems: 'center',
  }
})

export default withStyles(styles)(CardSearchLog)